import MenuPositioning1 from '@images/components/menu/MenuPositioning1_x2.png';
import MenuPositioning2 from '@images/components/menu/MenuPositioning2_x2.png';
import * as React from 'react';
export default {
  MenuPositioning1,
  MenuPositioning2,
  React
};